"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearchQueryValidation = exports.UpdateUsersRolesDtoValidation = exports.ForgetPasswordDtoValidation = exports.EditUserDtoValidation = exports.UserDtoValidation = exports.ChangePasswordDtoValidation = exports.RegisterCredentialsDtoValidation = exports.PasswordRequirements = exports.LoginCredentialsDtoValidation = exports.Role = exports.Hand = exports.Gender = exports.SkillLevel = void 0;
const yup = require("yup");
const app_1 = require("./app");
const phoneRegExp = /^[0-9]{10}$/;
var SkillLevel;
(function (SkillLevel) {
    SkillLevel["Beginner"] = "Beginner";
    SkillLevel["Intermediate"] = "Intermediate";
    SkillLevel["Advanced"] = "Advanced";
})(SkillLevel = exports.SkillLevel || (exports.SkillLevel = {}));
var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
    Gender["Other"] = "Other";
})(Gender = exports.Gender || (exports.Gender = {}));
var Hand;
(function (Hand) {
    Hand["Right"] = "Right";
    Hand["Left"] = "Left";
})(Hand = exports.Hand || (exports.Hand = {}));
var Role;
(function (Role) {
    Role["Mobile"] = "MOBILE";
    Role["Admin"] = "ADMIN";
})(Role = exports.Role || (exports.Role = {}));
exports.LoginCredentialsDtoValidation = yup.object({
    email: yup.string().email().required(),
    password: yup.string().min(4).max(30).required(),
});
exports.PasswordRequirements = {
    max: 32,
    min: 8,
    lowerCase: /[a-z]/,
    upperCase: /[A-Z]/,
    special: /[*.!@#$%^&(){}[\]:;<>,.?/~_+-=|]/,
};
const passwordMessages = {
    required: 'Password is required',
    min: 'Password must have at least 8 characters',
    max: 'Password must have no more than 32 characters',
    upperCase: 'Password must have at least 1 upper case letter',
    lowerCase: 'Password must have at least 1 lower case letter',
    special: 'Password must have at least 1 special character or number',
};
exports.RegisterCredentialsDtoValidation = yup.object({
    email: yup.string().email().required(),
    password: yup
        .string()
        .min(exports.PasswordRequirements.min, passwordMessages.min)
        .max(exports.PasswordRequirements.max, passwordMessages.max)
        .matches(exports.PasswordRequirements.upperCase, passwordMessages.upperCase)
        .matches(exports.PasswordRequirements.lowerCase, passwordMessages.lowerCase)
        .matches(exports.PasswordRequirements.special, passwordMessages.special)
        .required(passwordMessages.required),
    firstName: yup.string(),
    lastName: yup.string(),
    phone: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
});
exports.ChangePasswordDtoValidation = yup.object({
    newPassword: yup.string().min(4).max(30).required(),
    oldPassword: yup.string().min(4).max(30),
    token: yup.string(),
});
exports.UserDtoValidation = yup.object({
    id: yup.string(),
    email: yup.string().email().required(),
    roles: yup
        .array()
        .of(yup.mixed().oneOf(Object.values(Role)))
        .required(),
    firstName: yup.string(),
    lastName: yup.string(),
    phone: yup.string(),
    profiles: yup.array().of(yup.mixed()).required(),
});
exports.EditUserDtoValidation = yup.object({
    firstName: yup.string(),
    lastName: yup.string(),
    phone: yup.string(),
});
exports.ForgetPasswordDtoValidation = yup
    .object()
    .shape({
    email: yup
        .string()
        .email()
        .when('phone', {
        is: (phone) => !phone,
        then: yup.string().required('At least one field is required'),
    }),
    phone: yup
        .string()
        .matches(phoneRegExp, 'Phone number is not valid')
        .when('email', {
        is: (email) => !email,
        then: yup.string().required('At least one field is required'),
    }),
}, [['email', 'phone']]);
exports.UpdateUsersRolesDtoValidation = yup.object({
    roles: yup
        .array()
        .of(yup.mixed().oneOf(Object.values(Role)))
        .required(),
    usersIds: yup.array().of(yup.string()).min(1).required(),
});
exports.UserSearchQueryValidation = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    email: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
//# sourceMappingURL=auth.js.map